const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  variantUnavailable: 'variant-unavailable',
  cartError: 'cart-error',
  /* START DAWN MODIFICATION */
  quickAddLaunched: 'quick-add-launched'
  /* END DAWN MODIFICATION */
};
